<template>
    <div class="step-container">
        <div class="title">转服补偿领取步骤</div>
        <div class="inner-container">
            <ul class="step-box">
                <li v-for="(item, key) in steps" :key="key" :class="{active: key <= activeKey}">
                    <a :href="getPath(item, key)">
                        <div class="step">{{key+1}}</div>
                        <p>{{item.name}}</p>
                    </a>
                </li>
            </ul>
            <div class="slot-container">
                <slot/>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data () {
        return {
            steps: [
                {
                    path: '/',
                    name: '选择转服游戏'
                },
                {
                    path: '/step2',
                    name: '验证账号信息'
                },
                {
                    path: '/step3',
                    name: '选择接收游戏'
                }
            ],
            activeKey: 0
        }
    },
    mounted () {
        let sub_route = this.$route.path
        this.steps.map((obj, key) => {
            if(obj.path == sub_route) {
                this.activeKey = key
            }
        })
    },
    methods: {
        getPath(item, key) {
            let game = this.$route.query.app
            let parameter = game ? `?app=${game}` : ''

            return key < this.activeKey ? (item.path != '/' ? item.path+parameter : item.path) : 'javascript:;'
        }
    },
    beforeRouteEnter(to, from) {
        console.log(to)
        console.log(from)
    }
}
</script>

<style lang="scss" scoped>
.step-container {
    width: 900px;
    margin: 40px auto 200px;
    border: 1px solid $border;
    color: $black_txt;
    border-radius: 5px;
    >.title {
        height: 60px;
        line-height: 60px;
        padding-left: 20px;
        font-size: 20px;
        border-bottom: 1px solid $border;
    }
    .inner-container {
        padding: 0 72px;
        .step-box {
            display: flex;
            justify-content: space-around;
            padding: 30px 0 10px;
            border-bottom: 1px dashed $border;
            li {
                position: relative;
                width: 84px;
                background-color: #fff;
                a {
                    display: inline-block;
                    width: 100%;
                    height: 100%;
                }
                .step {
                    width: 40px;
                    height: 40px;
                    border-radius: 20px;
                    background-color: $gray;
                    color: #fff;
                    text-align: center;
                    line-height: 40px;
                    margin: 0 auto;
                }
                p {
                    color: $gray;
                    font-size: 14px;
                    margin: 15px 0;
                }

                &::before {
                    content: '';
                    width: 170px;
                    height: 1px;
                    background-color: #cccccc;
                    position: absolute;
                    top: 20px;
                    left: 85px;
                    @media screen and (max-width: 900px) {
                        width: 220px;
                    }
                    @media screen and (max-width: 600px) {
                        width: 140px;
                    }
                    @media screen and (max-width: 430px) {
                        width: 60px;
                    }
                }

                &:last-child {
                    &::before {
                        display: none;
                    }
                }

                &.active {
                    .step {
                        background-color: $active;
                    }
                    p {
                        color: $black_txt;
                    }
                }
            }
        }
        .slot-container {
            padding: 30px 0;
        }
    }
}

@media screen and (max-width: 900px) {
    .step-container {
        width: 95%;
        .inner-container {
            .step-box {
                justify-content: space-between;
            }
        }
    }
}

@media screen and (max-width: 768px) {
    .step-container {
        .inner-container {
            padding: 0 20px;
        }
    }
}
</style>